import { render, staticRenderFns } from "./ExercisePopup.vue?vue&type=template&id=000a9ace"
import script from "./ExercisePopup.vue?vue&type=script&lang=js"
export * from "./ExercisePopup.vue?vue&type=script&lang=js"
import style0 from "./ExercisePopup.vue?vue&type=style&index=0&id=000a9ace&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports